/**
 * @desc 海关要素-详情
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.CustomsInfoResponseDto>;
export function request(cino: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/customsInfo/details/${cino}`, {
      method: "GET",

      ...options,
    }),
  );
}
